<template>
    <div id="material_list" class="card-container">
        <div class="list">
            <template v-if="data && data.length > 0">
                <a-table
                    :columns="columns"
                    :data-source="data"
                    :rowKey="tableRowKey"
                    :pagination="page"
                >
                    <template slot="customTitle">
                        <div class="main_between cross_center">
                            {{ title }}
                            <router-link
                                to="/materials"
                                class="base_font_size_12 base_font_color_ff5800"
                                >添加素材</router-link
                            >
                        </div>
                    </template>
                    <template slot="action" slot-scope="text, record">
                        <a-card hoverable :bodyStyle="{ padding: '10px' }">
                            <div class="main_between cross_center" @click="selected(record)">
                                <div
                                    class="title dir_left_wrap cross_center"
                                    style="width: 70%;"
                                    :title="text"
                                >
                                    <div
                                        class="main_center cross_center"
                                        style="margin-right: 10px;width: 50px;height: 50px;"
                                        v-if="record.cover"
                                    >
                                        <a-tooltip placement="right">
                                            <template slot="title">
                                                <img :src="record.cover" width="100%" />
                                            </template>
                                            <img
                                                :src="record.cover"
                                                width="100%"
                                            />
                                        </a-tooltip>
                                    </div>
                                    <div class="t_omit" :style="{width: record.cover ? 'calc(100% - 60px)' : '100%'}">
                                        {{ text }}
                                    </div>
                                </div>
                                <a-icon
                                    type="check"
                                    v-if="record.isSelected"
                                    class="base_font_color_ff5800"
                                />
                            </div>
                        </a-card>
                    </template>
                </a-table>
            </template>
            <template v-else>
                <a-empty description="暂无数据" style="margin-top: 15px;" />
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        tableRowKey: {
            type: String,
            default: ''
        },
        tableTitle: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        data: {
            type: Array,
            default: function() {
                return [];
            }
        },
        page: {
            type: Object,
            default: function() {
                return {
                    total: 0,
                    pageSize: 10
                };
            }
        },
        params: {
            type: Object,
            default: function() {
                return {
                    mediaType: null,
                    page: 1,
                    categoryId: null
                };
            }
        }
    },
    data() {
        return {
            columns: [
                {
                    // title: this.title,
                    dataIndex: this.tableTitle,
                    slots: { title: 'customTitle' },
                    scopedSlots: { customRender: 'action' }
                }
            ]
        };
    },
    computed: {},
    mounted() {},
    watch: {},
    methods: {
        onSearch() {
            this.$emit('backParams', this.params);
        },
        selected(data) {
            this.data.forEach((item) => {
                if (data.id === item.id) {
                    item.isSelected = true;
                    this.$emit('backSelect', item);
                } else item.isSelected = false;
                return item;
            });
        }
    }
};
</script>

<style>
#material_list .list {
    min-height: 300px;
}
#material_list .ant-table-thead > tr > th .ant-table-header-column {
    width: 100%;
}
</style>
